// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"0a7e2ca2","488":"667e738f"}[chunkId] + ".chunk.js";
};